import { render, staticRenderFns } from "./TalentTraining.vue?vue&type=template&id=12f6628d&scoped=true&"
import script from "./TalentTraining.vue?vue&type=script&lang=js&"
export * from "./TalentTraining.vue?vue&type=script&lang=js&"
import style0 from "./TalentTraining.vue?vue&type=style&index=0&id=12f6628d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12f6628d",
  null
  
)

export default component.exports